module.exports = __webpack_public_path__ + "static/media/inbox.d51f7bec.svg";